module.exports = __webpack_public_path__ + "media/icons/close-99bda28d.svg";